module.exports = __webpack_public_path__ + "img/banner09_01-02.b8874d25.png";